import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddInitialState = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#4A5666",
		fillRule: "nonzero",
		children: /* @__PURE__ */ _jsx("path", { d: "M6 0a6 6 0 0 1 6 6H9v3H6v3A6 6 0 1 1 6 0M12.25 8v2.75H15v1.5h-2.75V15h-1.5v-2.75H8v-1.5h2.75V8z" })
	})
});
export default SvgAddInitialState;
